/*-----------------------------------------------------------------
- Blog Card
-----------------------------------------------------------------*/
export default {

    comments_count: '{0} دیدگاه',
    see_more      : 'ادامه مطلب',
    see_post      : 'مشاهده مطلب',

};
